export default __webpack_public_path__ + "2a4f6492cd93123daaf2fc2857bcaacd.png";